import React, { useState } from 'react'
import './Services.css'

const Services = () => {

    const [toggleState, setToggleState] = useState(0);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <section className="services section" id="services">
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What i offer</span>

            <div className="services__container container grid">
                <div className="services__content">
                    <div>
                        <i className="uil uil-web-grid services__icon"></i>
                        <h3 className="services__title">Frontend <br /> Developer</h3>
                    </div>

                    <span className="services__button" onClick={() => toggleTab(1)}>View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                    <div className={toggleState === 1 ? "services__model active-model" : "services__model"}>
                        <div className="services__model-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__model-close"></i>


                            <h3 className="services-model-title">Frontend Developer</h3>
                            <p className="services__model-description">With solid experience in frontend development, I provide high-quality work for clients and companies.</p>

                            <ul className="services__model-services">
                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I develop and implement user interfaces.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I focus on responsive web page development.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I create engaging interactions for web elements.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I ensure smooth integration in all designs.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I build functional and attractive websites.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="services__content">
                    <div>
                        <i className="uil uil-arrow services__icon"></i>
                        <h3 className="services__title">Website <br /> Developer</h3>
                    </div>

                    <span onClick={() => toggleTab(2)} className="services__button">View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                    <div className={toggleState === 2 ? "services__model active-model" : "services__model"}>
                        <div className="services__model-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__model-close"></i>


                            <h3 className="services-model-title">Website Developer</h3>
                            <p className="services__model-description">I build complete, fully functional websites with frontend and backend integration.</p>

                            <ul className="services__model-services">
                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">
                                        I create modern and responsive user interfaces.
                                    </p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">
                                        I provide complete backend functionality.
                                    </p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">
                                        I ensure secure data management.
                                    </p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">
                                        I deliver seamless integration of all features.
                                    </p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">
                                        I build fast and reliable websites.
                                    </p>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>

                <div className="services__content">
                    <div>
                        <i className="uil uil-edit services__icon"></i>
                        <h3 className="services__title">Media <br /> Editor</h3>
                    </div>

                    <span onClick={() => toggleTab(3)} className="services__button">View More <i className="uil uil-arrow-right services__button-icon"></i></span>

                    <div className={toggleState === 3 ? "services__model active-model" : "services__model"}>
                        <div className="services__model-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__model-close"></i>


                            <h3 className="services-model-title">Media Editor</h3>
                            <p className="services__model-description">With 4 years of experience in photo and video editing, I provide high-quality work for clients and companies.</p>

                            <ul className="services__model-services">
                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I edit in various PC and mobile applications.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I ensure smooth integration of media elements.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I create transitions and cuts to enhance videos.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I specialize in photo editing and color grading.</p>
                                </li>

                                <li className="services-model-service">
                                    <i className="uil uil-check-circle services__model-icon"></i>
                                    <p className="services__model-info">I enhance the quality of images and videos.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services